import React, { memo, useMemo } from 'react';
import { Line } from 'react-chartjs-2';

import { IChartData } from './interfaces';

import { historyCheckChartOptions } from './constants';

import { prepareHistoryCheckChartData } from './utils';

import styles from './HistoryCheckChart.module.scss';

interface IHistoryCheckChartProps {
	chartData: IChartData[];
	selectedDate?: string;
}

const HistoryCheckChart = ({
	chartData,
	selectedDate,
}: IHistoryCheckChartProps) => {
	const preparedData = useMemo(() => prepareHistoryCheckChartData(chartData), [chartData]);

	return (
		<div className={styles.chartWrapper}>
			{selectedDate &&
				<div className={styles.chartInfoWrapper}>
					<span className={styles.chartTime}>Days / Hours</span>
					<span className={styles.chartInfo}>{selectedDate}</span>
				</div>
			}
			<Line
				data={preparedData}
				options={historyCheckChartOptions}
			/>
		</div>
	);
};

export default memo(HistoryCheckChart);
